var _circle, _circle2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPol = function SvgPol(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    width: "1em",
    height: "1em"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 250,
    fill: "#7613FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 220,
    fill: "#60F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M466.506 125A250 250 0 0 1 375 466.506 250 250 0 0 1 33.494 375L250 250Z",
    opacity: 0.34
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m320.83 302.85 69.29-40.01c3.67-2.12 5.94-6.06 5.94-10.3v-80.01c0-4.23-2.28-8.18-5.94-10.3l-69.29-40.01a11.934 11.934 0 0 0-11.89 0l-69.29 40.01a11.926 11.926 0 0 0-5.94 10.3v142.99l-48.59 28.05-48.59-28.05v-56.11l48.59-28.05 32.05 18.5v-37.64l-26.11-15.07a11.914 11.914 0 0 0-11.89 0l-69.29 40.01a11.913 11.913 0 0 0-5.94 10.3v80.01c0 4.23 2.28 8.18 5.94 10.3l69.29 40.01c3.66 2.11 8.22 2.11 11.89 0l69.29-40c3.67-2.12 5.94-6.07 5.94-10.3V184.49l.88-.5 47.71-27.55 48.59 28.05v56.11l-48.59 28.05-32-18.48v37.64l26.06 15.05c3.67 2.11 8.22 2.11 11.89 0Z"
  })));
};
export default SvgPol;